import m from "../../geodata/es2015/belarusLow";
window.am4geodata_belarusLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/belarusLow.js
// module id = null
// module chunks = 